<template>
    <table v-if="isEditing" class="channels-container">
        <tbody>
            <tr class="channels-labels">
                <td></td>
                <td class="param" v-for="(param, i) in channelParams.filter(param => param.view.name.includes('IC50'))"
                    :key="param.name">
                    <div class="channel-label">
                        {{ param.view.name.substring(5) }}
                        <hr :style="{ backgroundColor: colors[i], height: '3px', width: '70%', borderWidth: 0 }">
                    </div>
                </td>
            </tr>
            <tr>
                <td class="parameter-label">IC50 (nmol/L)</td>
                <td class="param" v-for="(param, i) in channelParams.filter(param => param.view.name.includes('IC50'))"
                    :key="param.name">
                    <sub-field-list-input-container :fieldConfig="param" :showTooltip="false" :showLabel="false"
                        v-on="$listeners" @change="modify"></sub-field-list-input-container>
                </td>
            </tr>
            <tr>
                <td class="parameter-label">H</td>
                <td class="param" v-for="(param) in channelParams.filter(param => param.view.name.includes('H'))"
                    :key="param.name">
                    <sub-field-list-input-container :fieldConfig="param" :showTooltip="false" :showLabel="false"
                        v-on="$listeners" @change="modify"></sub-field-list-input-container>
                </td>
            </tr>
        </tbody>
    </table>
    <div v-else>
        <div class="field-label">IC50</div>
        <div class="ion-channels-legend">
            <div class="channel" v-for="(channel,i) in channelParams.filter(channel => channel.channel.includes('IC50'))" :key="channel.channel">
                <div class="channel-label">
                    {{channel.channel.substring(5)}}
                    <hr :style="{backgroundColor: colors[i], height: '3px', width: '70%', borderWidth: 0}">
                </div>
                <div>{{channel.value}}</div>
            </div>
        </div>
        <div class="field-label">H</div>
        <div class="ion-channels-legend">
        <div class="channel" v-for="(channel,i) in channelParams.filter(channel => channel.channel.includes('H'))" :key="channel.channel">
            <div class="channel-label">
                {{channel.channel.substring(2)}}
                <hr :style="{backgroundColor: colors[i], height: '3px', width: '70%', borderWidth: 0}">
            </div>
            <div>{{channel.value}}</div>
        </div>
        </div> 
    </div>
</template>


<script>
import ValueInputContainer from './ValueInputContainer.vue'
import SubFieldListInputContainer from './SubFieldListInputContainer'
import d3 from '@/utils/d3importer'

export default {
    name: 'IonChannels',
    components: { ValueInputContainer, SubFieldListInputContainer},
    model:{
        prop: 'fieldConfig',
        event: 'change'
    },
    props: {
        fieldConfig: Object,
        channelParams: Array,
        isEditing: Boolean
    },
    computed: {
        colors() {
            let channels = Array.from(this.channelParams.slice(0,this.channelParams.length/2).keys())
            return channels.map(i => d3.schemePaired[i])
        },
    },
    methods: {
        modify() {
            let deepChannelParams = JSON.parse(JSON.stringify(this.channelParams));
            let channelData = deepChannelParams.map((channel,i) => {
                return {channel: channel.view.name, value: channel.value}
            })
            this.$emit('modify', channelData)
        }
    }
}
</script>

<style lang="stylus">
    .channels-container
        position: relative
        margin-top: 10px
        display: flex
        flex-direction: row
        justify-content: flex-start
        padding: 0 10px

        .channels-labels
            text-align: center

        .channel-label
            color: $shuttle-gray
            m-font-size(12, 14)
            padding-bottom: 10px

        .parameter-label
            color: #515662
            m-font-size(12, 14)
            width: 30px
            margin: 30px 0 0 10px

    .field-label
        margin-left: 2px
        color: $shuttle-gray
        m-font-size(12, 14)
    .ion-channels-legend
        display: flex
        flex-direction: row
        flex-wrap: wrap
        text-align: center
        margin: 0 auto
        .channel
            width: 70px
            margin: 10px auto

        .channel-label
            color: $shuttle-gray
            m-font-size(10, 12)
            padding-bottom: 10px
</style>
